import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const selectTableId = (table) => table._id || table.id;
const tablesAdapter = createEntityAdapter({ selectId: selectTableId });

const initialState = tablesAdapter.getInitialState({});

const tablesSlice = createSlice({
	name: 'tables',
	initialState,
	reducers: {
		setTables: (state, action) => {
			tablesAdapter.setAll(state, action.payload || []);
		},
		upsertTables: (state, action) => {
			tablesAdapter.upsertMany(state, action.payload || []);
		},
		upsertTable: (state, action) => {
			tablesAdapter.upsertOne(state, action.payload);
		},
		removeTableById: (state, action) => {
			tablesAdapter.removeOne(state, action.payload);
		},
		clearTables: (state) => {
			tablesAdapter.removeAll(state);
		},
	},
});

export const { setTables, upsertTables, upsertTable, removeTableById, clearTables } = tablesSlice.actions;
export default tablesSlice.reducer;

const selectTablesState = (state) => state.tables;
export const { selectAll: selectAllTables, selectById: selectTableById, selectIds: selectTableIds } =
	tablesAdapter.getSelectors(selectTablesState);


